package amazon.lastmile.inject

import app.nestbridge.feature.children.ui.ChildrenUiFactory
import com.slack.circuit.runtime.ui.Ui
import me.tatarka.inject.annotations.IntoSet
import me.tatarka.inject.annotations.Provides
import software.amazon.lastmile.kotlin.inject.anvil.`internal`.Origin

@Origin(value = ChildrenUiFactory::class)
public interface AppNestbridgeFeatureChildrenUiChildrenUiFactory {
  @Provides
  @IntoSet
  public fun provideChildrenUiFactoryFactoryMultibinding(childrenUiFactory: ChildrenUiFactory): Ui.Factory = childrenUiFactory
}
